import { render, staticRenderFns } from "./separate.vue?vue&type=template&id=d7ec884c&scoped=true&"
import script from "./separate.vue?vue&type=script&lang=js&"
export * from "./separate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ec884c",
  null
  
)

export default component.exports